import { Component, OnInit, Input } from '@angular/core';
import { DeviceManagementService } from '../device-management.service';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { DeviceFactory } from 'src/app/home/site-dashboard/device/device-factory/device-factory';

@Component({
	selector: 'app-reverse-events',
	templateUrl: './reverse-events.component.html',
})
export class ReverseEventsComponent implements OnInit {

	@Input() device: any = {};
	@Input() study: any = {};
	@Input() currentSite: any = {};

	startId;
	endId;
	isIMDevice = false;
	
	constructor(
		private deviceManagementService: DeviceManagementService,
		private notificationMessage: NotificationMessageService,
		private commonService: CommonService,
		private translateService: TranslateService
	){}

	ngOnInit() {
		this.isIMDevice = DeviceFactory.isIMDeviceType(this.device?.config_info?.sct_device_type);

		if (this.study && this.study.id)
			this.commonService.setPageTabTitle(`${this.translateService.instant('studies.power_studies')} - ${this.study.name} - ${this.translateService.instant('command_name.reverse_events')}`);
		else
			this.commonService.setPageTabTitle(`${this.currentSite.customer_name} - ${this.currentSite.name} - ${this.device.serial_number} - ${this.translateService.instant('command_name.reverse_events')}`);
	}

	reverseEvents() {
		if(!this.startId || !this.endId || this.startId > this.endId)
			return this.notificationMessage.setMessage('translate|g.invalid_input', {clearOnXTimeNavigate: 1});
		
		if (Object.keys(this.study).length && !this.studyReversEventsValidation())
			return this.notificationMessage.setMessage('translate|studies.reverse_events_validation', {clearOnXTimeNavigate: 1});

		const studyId = this.study?.id || 0;
		this.deviceManagementService.reverseEvents(this.device.mac_address, this.startId, this.endId, studyId).subscribe(()=>{
			this.startId = this.endId = null;
			this.notificationMessage.setMessage('globalSuccessMsg',{clearOnXTimeNavigate: 1});
		});
	};

	studyReversEventsValidation() {
		if (this.startId < this.study.start_event_id || (this.study.is_done && this.endId > this.study.end_event_id))
			return false;
		return true;
	}
}